import React from 'react';

import clsx from 'clsx';

import {
  HIDE_PRODUCT_QUANTITY,
  MAX_PRODUCT_QUANTITY_LIMIT,
  UNLIMITED_PRODUCT_QUANTITY,
} from 'data/common';
import Minus from 'ui/Icon/icons/Minus';
import PlusIcon from 'ui/Icon/icons/Plus';

function QuantityInput({
  quantity,
  minQuantity,
  isChangeLoading,
  quantityRange = MAX_PRODUCT_QUANTITY_LIMIT,
  handleDecrementQuantity,
  handleIncrementQuantity,
  handleQuantityChange,
}: {
  quantity: number;
  minQuantity: number;
  isChangeLoading: boolean;
  quantityRange?: number;
  handleDecrementQuantity: () => void;
  handleIncrementQuantity: () => void;
  handleQuantityChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const shouldDisable = isChangeLoading || quantityRange === HIDE_PRODUCT_QUANTITY;
  const shouldExcceedMaxLimit =
    quantityRange !== HIDE_PRODUCT_QUANTITY &&
    quantityRange !== UNLIMITED_PRODUCT_QUANTITY &&
    quantity >= quantityRange;

  return (
    <fieldset className="group w-[105px] h-[38px] relative border border-dividerGrey rounded-md">
      <button
        id="decrement"
        type="button"
        disabled={shouldDisable}
        className={clsx(
          shouldDisable && 'opacity-50 cursor-not-allowed',
          'decrement-left-large absolute h-6 w-6 flex items-center justify-center left-2 top-[6px]',
        )}
        onClick={handleDecrementQuantity}
      >
        <Minus />
      </button>
      <input
        className="w-full px-8 h-full text-center text-base font-normal text-gray-700 rounded-md outline-none ring-transparent focus:border-0 focus:ring-0 focus:outline-none border-0"
        style={{
          fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          fontVariantNumeric: 'tabular-nums', // optional: prevents digit wobble
        }}
        type="number"
        disabled={shouldDisable}
        readOnly={shouldDisable}
        value={isNaN(quantity) ? '' : quantity}
        min={minQuantity}
        onChange={handleQuantityChange}
      ></input>
      <button
        id="increment"
        type="button"
        disabled={shouldDisable || shouldExcceedMaxLimit}
        className={clsx(
          (shouldDisable || shouldExcceedMaxLimit) && 'opacity-50 cursor-not-allowed',
          'increment-right-large absolute h-6 w-6 flex items-center justify-center right-2 top-[6px]',
        )}
        onClick={handleIncrementQuantity}
      >
        <PlusIcon />
      </button>
    </fieldset>
  );
}

export default QuantityInput;
